'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIpad = function IoIpad(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.5 5.7c0-0.4 0.3-0.7 0.7-0.7h21.1c0.4 0 0.7 0.3 0.7 0.7v28.6c0 0.4-0.3 0.7-0.7 0.7h-21.1c-0.4 0-0.7-0.3-0.7-0.7v-28.6z m11.3 28.5c0.6 0 1-0.4 1-1.1s-0.5-1.1-1-1.1c-0.7 0-1.1 0.5-1.1 1.1s0.4 1.1 1.1 1.1z m-8.8-24.9v21.5c0 0.3 0.2 0.5 0.5 0.5h16.5c0.2 0 0.5-0.2 0.5-0.5v-21.5c0-0.3-0.3-0.5-0.5-0.5h-16.5c-0.3 0-0.5 0.2-0.5 0.5z' })
        )
    );
};

exports.default = IoIpad;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ipad.js
// module id = 2806
// module chunks = 168707334958949